Dodano nową sesję publiczną
<lib-quick-link
  [contextId]="details.publicSessionId"
  [context]="'PublicSession'"
></lib-quick-link>
<lib-quick-cover
  [contextId]="details.publicSessionId"
  [context]="'PublicSession'"
  [maxSize]="2048"

  [routerLink]="('PublicSession' | quickLinkForRouter:details.publicSessionId) | async"

></lib-quick-cover>
